import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPQualityParameterTableDataAPI = createAsyncThunk("STPQualityParameterTableData", async ({ data }) => {
    const {
        M_IndicatorParameterTypeID,
        M_STP_QualityParameterID,
        M_UserID,
        token,
        From,
        To,
        handleSTPQualityParameterExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_STP_QualityParameter_Select?M_IndicatorParameterTypeID=${M_IndicatorParameterTypeID ? M_IndicatorParameterTypeID : '0'}&M_STP_QualityParameterID=${M_STP_QualityParameterID ? M_STP_QualityParameterID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleSTPQualityParameterExport && handleSTPQualityParameterExport()
                return result.data

            } else {
                return result
            }
        })
})

const STPQualityParameterTableDataSlice = createSlice({
    name: "STPQualityParameterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPQualityParameterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPQualityParameterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPQualityParameterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPQualityParameterTableDataReducer = STPQualityParameterTableDataSlice.reducer


export const STPQualityParameterTableExportDataAPI = createAsyncThunk("STPQualityParameterTableExportData", async ({ data }) => {
    const {
        M_IndicatorParameterTypeID,
        M_STP_QualityParameterID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_STP_QualityParameter_Select?M_IndicatorParameterTypeID=${M_IndicatorParameterTypeID ? M_IndicatorParameterTypeID : '0'}&M_STP_QualityParameterID=${M_STP_QualityParameterID ? M_STP_QualityParameterID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPQualityParameterTableExportDataSlice = createSlice({
    name: "STPQualityParameterTableExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPQualityParameterTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(STPQualityParameterTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(STPQualityParameterTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPQualityParameterTableExportDataReducer = STPQualityParameterTableExportDataSlice.reducer



export const STPQualityParameterPostDataAPI = createAsyncThunk("STPQualityParameterPostData", async ({ data }) => {
    const {
        M_STP_QualityParameterID,
        M_IndicatorParameterTypeID,
        QualityParameterName,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_STP_QualityParameterID", M_STP_QualityParameterID);
    formdata.append("M_IndicatorParameterTypeID", M_IndicatorParameterTypeID);
    formdata.append("QualityParameterName", QualityParameterName);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_STP_QualityParameter_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const STPQualityParameterPostDataSlice = createSlice({
    name: "STPQualityParameterPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPQualityParameterPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPQualityParameterPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPQualityParameterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPQualityParameterPostDataReducer = STPQualityParameterPostDataSlice.reducer

// -----------------Delete API ---------------

export const STPQualityParameterDeleteAPI = createAsyncThunk("STPQualityParameterDelete", async ({ data }) => {
    const {
        M_STP_QualityParameterID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_STP_QualityParameterID", M_STP_QualityParameterID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_M_STP_QualityParameter_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPQualityParameterDeleteSlice = createSlice({
    name: "STPQualityParameterDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPQualityParameterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPQualityParameterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPQualityParameterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPQualityParameterDeleteReducer = STPQualityParameterDeleteSlice.reducer